export const formateDateDDMMYY = (date) => {
  const nextDay = new Date(date);
  nextDay.setDate(date.getDate());
  const day = String(nextDay.getDate()).padStart(2, "0");
  const month = String(nextDay.getMonth() + 1).padStart(2, "0");
  const year = nextDay.getFullYear();

  return `${year}/${month}/${day}`;
};
